export const GET_VIDEO_REPORT="GET_VIDEO_REPORT"
export const DELETE_VIDEO_REPORT="DELETE_VIDEO_REPORT"
export const CLEAN_REPORT = "CLEAN_REPORT";
export const GET_REPORT_STATS_DATA = "GET_REPORT_STATS_DATA";
